// extracted by mini-css-extract-plugin
export default {"investments":"Investments_investments__dDP4C","loading":"Investments_loading__Vw+YA","empty":"Investments_empty__1p7j+"};